module.exports = __webpack_public_path__ + "static/media/SCB_Corona-Lageplan_nru_2009010_L3-1.38a292a2.png";